import $ from "jquery";

export default function ajax(options) {
	/* tokens are only passed if exists and url is same-origin and under the same db path, to prevent leaking tokens to third-party */
	if (window.gApiConfig.fetchToken) {
		const locationPathPrefix = location.href.replace(/^(.*\/db\/[-\d]+\/).*/i, "$1");
		const url = new URL(options.url, locationPathPrefix);
		const urlPathPrefix = url.href.replace(/^(.*\/db\/[-\d]+\/).*/i, "$1");
		if (locationPathPrefix.toLowerCase() === urlPathPrefix.toLowerCase()) {
			const fetchTokenHeaderName = "X-Fetch-Token";
			// copy headers, set X-Fetch-Token if not set, and assign back to options
			if (!options.headers || !options.headers[fetchTokenHeaderName]) {
				const headers = Object.assign({}, options.headers, { [fetchTokenHeaderName]: window.gApiConfig.fetchToken });
				options = Object.assign({}, options, { headers });
			}
		}
	}
	return $.ajax(options);
}